import * as React from "react";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import TLabel from "../Labels/TLabel";

class TRadioGroup extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        caption: PropTypes.string,
        handleChange: PropTypes.func,
        style: PropTypes.object,
        itemIndex: PropTypes.number,
        items: PropTypes.arrayOf(PropTypes.string),
        info: PropTypes.arrayOf(PropTypes.any),
        row: PropTypes.bool,
    };

    static defaultProps = {
        caption: "", //'This is a label',
        handleChange: () => console.log("onClick"),
        style: {},
        itemIndex: 0,
        items: ["Item1", "Item2", "Item3"],
        info: [],
        row: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            itemIndex: 0,
        };
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    handleChange = (obj, value) => {
        this.props.handleChange(parseInt(value, 10), this.props.info[value]);
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderItems = () => {
        let items = [];

        for (let i = 0; i <= this.props.items.length - 1; i++) {
            items.push(
                <FormControlLabel
                    value={i.toString()}
                    control={<Radio />}
                    label={this.props.items[i]}
                    key={i}
                />
            );
        }

        return items;
    };

    render() {
        let value = this.props.itemIndex;

        if (typeof value === "number") {
            value = value.toString();
        }

        return (
            <FormControl
                component="fieldset"
                style={this.props.style}
            >
                <TLabel
                    style={{ color: "#000000" }}
                    caption={this.props.caption}
                />
                <RadioGroup
                    aria-label="Gender"
                    name="gender1"
                    value={value}
                    onChange={this.handleChange}
                    row={this.props.row}
                >
                    {this.renderItems()}
                </RadioGroup>
            </FormControl>
        );
    }
}

export default TRadioGroup;
